/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ checked: NonNullable<unknown>, total: NonNullable<unknown> }} Overview_Checked_In_CountInputs */



/**
* | output |
* | --- |
* | "{checked} / {total} checked in" |
*
* @param {Overview_Checked_In_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_checked_in_count = /** @type {((inputs: Overview_Checked_In_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Checked_In_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.checked} / ${i?.total} pointés`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.checked} / ${i?.total} con check-in`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.checked} / ${i?.total} com check-in`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.checked} / ${i?.total} check in effettuati`)
	return /** @type {LocalizedString} */ (`${i?.checked} / ${i?.total} checked in`)
});